import tw, { styled } from "twin.macro";

export const QuoteWithBar = styled.div`
  box-shadow: inset 4px 0 0 0 #56ccf2;
  padding-left: 19px;
`;

export const QuoteWithBarNew = styled.div`
  ${tw`text-[#737880] leading-[32px]`}
  box-shadow: inset 4px 0 0 0 #2f75ff;
  padding-left: 19px;
`;

export const QuoteWithMarks = styled.div`
  ${tw`flex flex-row gap-0`}

  .fas {
    ${tw`text-theme-blue-1 font-black align-top`}
    width: 19px;
    height: 28px;
    font-size: 21px;
    line-height: 21px;

    &.fa-quote-left {
      ${tw`pr-1`}
    }

    &.fa-quote-right {
      ${tw`pl-1`}
    }
  }
`;

export const QuoteWithMarksWhite = styled.div`
  ${tw`flex flex-row gap-0`}

  .fas {
    ${tw`text-white font-black align-top`}
    width: 19px;
    height: 28px;
    font-size: 21px;
    line-height: 21px;

    &.fa-quote-left {
      ${tw`pr-1`}
    }

    &.fa-quote-right {
      ${tw`pl-1`}
    }
  }
`;

export const TestimonialHighlight = styled.span`
  ${tw`font-extrabold`}
`;

export const TestimonialHighlightBlue = styled.span`
  ${tw`font-extrabold text-blue-500`}
`;
